export const launcherModules = [
  {
    id: 'posts',
    command: 'publicaciones',
    aliases: ['publicaciones', 'productos', 'items', 'catalogo', 'posts'],
    titleKey: 'MAIN.POSTS',
    link: '/posts',
    icon: 'file-invoice',
    requiredPermission: 'posts.view',
    modes: ['gestion'],
    keywords: ['publicaciones', 'productos', 'items', 'catalogo', 'mercado libre']
  },
  {
    id: 'stock',
    command: 'stock',
    aliases: ['stock', 'inventario', 'depositos', 'almacenes', 'warehouses'],
    titleKey: 'MAIN.STOCK',
    link: '/stock',
    icon: 'box',
    requiredPermission: 'stock.view',
    modes: ['gestion'],
    keywords: ['stock', 'inventario', 'ubicaciones', 'depositos', 'warehouses']
  },
  {
    id: 'agents',
    command: 'agentes',
    aliases: ['agentes', 'bots', 'mapa', 'agents'],
    titleKey: 'MAIN.AGENTS',
    link: '/agents',
    icon: 'cog',
    requiredPermission: 'agents.view',
    modes: ['gestion'],
    keywords: ['agentes', 'bots', 'mapa']
  },
  {
    id: 'integrations',
    command: 'integraciones',
    aliases: ['integraciones', 'conexion', 'integrations'],
    titleKey: 'MAIN.INTEGRATIONS',
    link: '/integrations',
    icon: 'plug',
    requiredPermission: 'integrations.view',
    modes: ['gestion'],
    keywords: ['integraciones', 'mercado libre', 'conexion']
  },
  {
    id: 'notifications',
    command: 'notificaciones',
    aliases: ['notificaciones', 'alertas', 'notifications'],
    titleKey: 'MAIN.NOTIFICATIONS',
    link: '/social/notifications',
    icon: 'bell',
    requiredAnyPermissions: [
      'notifications.view_internal',
      'notifications.view_mercadolibre',
      'notifications.view_questions'
    ],
    modes: ['gestion'],
    keywords: ['notificaciones', 'alertas']
  },
  {
    id: 'dev-testing',
    command: 'testing',
    aliases: ['testing', 'dev', 'desarrollo'],
    titleKey: 'MAIN.DEV_TESTING',
    link: '/dev-testing',
    icon: 'tools',
    requiredPermission: 'dev_testing.view',
    modes: ['gestion'],
    keywords: ['testing', 'desarrollo']
  },
  {
    id: 'users',
    command: 'usuarios',
    aliases: ['usuarios', 'users'],
    titleKey: 'MAIN.USERS',
    link: '/users',
    icon: 'users',
    requiredPermission: 'users.view',
    modes: ['gestion'],
    keywords: ['usuarios']
  },
  {
    id: 'profiles',
    command: 'perfiles',
    aliases: ['perfiles', 'roles', 'profiles'],
    titleKey: 'MAIN.PROFILES',
    link: '/profiles',
    icon: 'user-circle',
    requiredPermission: 'profiles.view',
    modes: ['gestion'],
    keywords: ['perfiles', 'roles']
  },
  {
    id: 'questions',
    command: 'preguntas',
    aliases: ['preguntas', 'consultas', 'qa', 'questions'],
    titleKey: 'MAIN.QUESTIONS',
    link: '/questions',
    icon: 'question-circle',
    requiredPermission: 'questions.view',
    modes: ['gestion'],
    keywords: ['preguntas', 'qa', 'consultas']
  },
  {
    id: 'calendar',
    command: 'calendario',
    aliases: ['calendario', 'agenda', 'calendar'],
    titleKey: 'MAIN.CALENDAR',
    link: '/calendar',
    icon: 'calendar-alt',
    requiredPermission: 'calendar.view',
    modes: ['gestion'],
    keywords: ['calendario', 'agenda', 'operacion', 'eventos']
  },
  {
    id: 'messages',
    command: 'mensajes',
    aliases: ['mensajes', 'mensajeria', 'chats', 'messages'],
    titleKey: 'MAIN.MESSAGES',
    link: '/messages',
    icon: 'comments',
    requiredPermission: 'messages.view_internal',
    modes: ['gestion'],
    keywords: ['mensajes', 'mensajeria', 'interna', 'chats']
  },
  {
    id: 'ml-messages',
    command: 'ml-mensajes',
    aliases: ['ml', 'mensajes-ml', 'mercadolibre-messages', 'postventa'],
    titleKey: 'MAIN.ML_MESSAGES',
    link: '/mercadolibre-messages',
    icon: 'comment',
    requiredPermission: 'messages.view_mercadolibre',
    modes: ['gestion'],
    keywords: ['mensajes ml', 'mercado libre', 'postventa']
  },
  {
    id: 'sales',
    command: 'ventas',
    aliases: ['ventas', 'pedidos', 'sales', 'orders'],
    titleKey: 'MAIN.SALES',
    link: '/sales',
    icon: 'shopping-cart',
    requiredPermission: 'sales.view',
    modes: ['gestion'],
    keywords: ['ventas', 'pedidos', 'orders']
  },
  {
    id: 'claims',
    command: 'reclamos',
    aliases: ['reclamos', 'claims'],
    titleKey: 'MAIN.CLAIMS',
    link: '/claims',
    icon: 'exclamation-triangle',
    requiredPermission: 'claims.view',
    modes: ['gestion'],
    keywords: ['reclamos', 'claims']
  },
  {
    id: 'bans',
    command: 'bloqueos',
    aliases: ['bloqueos', 'baneos', 'bans'],
    titleKey: 'MAIN.BANS',
    link: '/bans',
    icon: 'ban',
    requiredPermission: 'bans.view',
    modes: ['gestion'],
    keywords: ['bloqueos', 'baneos']
  },
  {
    id: 'partners',
    command: 'partners',
    aliases: ['partners', 'partner', 'socios'],
    titleKey: 'PARTNERS.MENU',
    link: '/partners',
    icon: 'users',
    requiredPermission: 'partners.view',
    modes: ['partners'],
    keywords: ['partner', 'referrals', 'link']
  },
  {
    id: 'blog',
    command: 'blog',
    aliases: ['blog', 'contenido', 'posts-publicos'],
    titleKey: 'BLOG.MENU',
    link: '/blog',
    icon: 'pen-nib',
    requiredPermission: 'blog.view',
    modes: ['blog'],
    keywords: ['blog', 'contenido', 'landing']
  },
  {
    id: 'super-admin',
    command: 'superadmin',
    aliases: ['superadmin', 'super-admin', 'platform'],
    titleKey: 'SUPERADMIN.TITLE',
    link: '/super-admin',
    icon: 'crown',
    requiresSuperAdmin: true,
    modes: ['superadmin'],
    keywords: ['platform', 'companies', 'waitlist']
  }
];
